import React, {useState, useEffect} from "react";
import { Redirect } from 'react-router-dom';
import validator from "validator";
import axios from "axios";
import theme from "../../theme/theme.js";
import Footer from "../../components/Footer/Footer.js";
import { useAuth } from '../../contexts/auth';
import { login } from '../../reducers/auth';
import { postLoginURL } from '../../utils/api';
import { setAuthentication } from '../../utils/localStorage';
// Chakra imports
import {
  ChakraProvider,
  Box,
  Flex,
  Button,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Link,
  Switch,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Assets
import signInImage from "assets/img/signInImage.png";
import aboutLeftImage from "assets/images/about-left-image.png";

function SignIn(props) {
  const [errors, setErrors] = useState([]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [ invEmail, setInvEmail ] = useState(null);
  const [ invPassword, setInvPassword ] = useState(null);
  const [ loggingIn, setLoggingIn ] = useState(false);
  const { auth, authDispatch } = useAuth();
 
  // Chakra color mode
  const titleColor = useColorModeValue("teal.300", "teal.200");
  const textColor = useColorModeValue("gray.400", "white");


  const postLogin = (e) => {
    e.preventDefault();

    setLoggingIn(true);
    setErrors([]);
    // console.log(email, password);
    axios.post(postLoginURL, {
        email,
        password
    }).then(result => {
        if (result.status === 200) {
            // const roles = result.data.data.user.roles;

            const user = result.data.data;
            user.authToken = result.data.authToken;
        
            // console.log(result.data.data)
            setAuthentication(user)
            authDispatch(login(user))
        } else {
            setErrors(result.data.errors);
        }
    }).catch(e => {
        if (e.response === undefined) {
            setErrors(['Could not connect to server!'])
        } else {
            setErrors(e.response.data.errors)
        }
    }).finally(e => {
      setLoggingIn(false);
    });
  }

  useEffect(() => {

    if (!validator.isEmpty(email)) {
      setInvEmail(!validator.isEmail(email));
    }
    if (!validator.isEmpty(password)) {
      setInvPassword(password.length <= 8);
    }

  }, [email, password]);

  if (auth) {
    var defaultPath = '/account';
    if (auth.role == 'manager') {
      defaultPath = '/admin/dashboard';
    } else if (auth.role == 'personnel') {
      defaultPath = '/personnel/inventory';
    } else if (auth.role == 'auditor') {
      defaultPath = '/auditor/inventory';
    } else if (auth.role == 'clerk') {
      defaultPath = '/clerk/tools';
    } else {
      defaultPath = '/users/account';
    }

    // console.log(defaultPath);

    // const pathname = props.location.state ? props.location.state.referer.pathname : defaultPath;
    const pathname = defaultPath;

    // console.log(`Should redirect to ${pathname}`)
    return <Redirect to={{ pathname, state: { referer: props.location } }} />;
  }


  return (
    <ChakraProvider theme={theme} resetCss={false} w="100%">
      <Box w="100%">
        <Box w="100%">
          <Box w="100%">
            <Flex position="relative" mb="40px">
              <Flex
                h={{ sm: "initial", md: "75vh", lg: "85vh" }}
                w="100%"
                maxW="400px"
                mx="auto"
                justifyContent="space-between"
                mb="30px"
                pt={{ sm: "100px", md: "0px" }}
              >
                <Flex
                  alignItems="center"
                  justifyContent="center"
                  style={{ userSelect: "none" }}
                  w={{ base: "100%", md: "100%", lg: "100%" }}
                >
                  <Flex
                    direction="column"
                    w="100%"
                    background="transparent"
                    p="48px"
                    mt={{ md: "150px", lg: "80px" }} 
                  >
                    <Heading color={titleColor} fontSize="32px" mb="10px" 
                      textAlign="center">
                      Welcome Back
                    </Heading>
                    <Text
                      mb="36px"
                      ms="4px"
                      color={textColor}
                      fontWeight="bold"
                      fontSize="14px"
                      textAlign="center"
                    >
                      Enter your email and password to sign in
                    </Text>
                    { errors.length > 0 &&<Text color="red">{errors[0]}</Text> }
                           
                    <form onSubmit={postLogin}>
                      <FormControl >
                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                          Email
                        </FormLabel>
                        <Input
                          borderRadius="15px"
                          mb="24px"
                          fontSize="sm"
                          type="text"
                          placeholder="Your email adress"
                          size="lg" 
                          isInvalid={invEmail === true}
                          isRequired={true}
                          value={email} 
                          onChange={e => setEmail(e.target.value)}
                        />
                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                          Password
                        </FormLabel>
                        <Input
                          borderRadius="15px"
                          mb="36px"
                          fontSize="sm"
                          type="password"
                          placeholder="Your password"
                          size="lg"
                          isInvalid={invPassword === true}
                          isRequired={true}
                          value={password} 
                          onChange={e => setPassword(e.target.value)}
                        />
                        <Button
                          fontSize="10px"
                          type="submit"
                          bg="teal.300"
                          w="100%"
                          h="45"
                          mb="20px"
                          color="white"
                          mt="0px"
                          _hover={{
                            bg: "teal.200",
                          }}
                          _active={{
                            bg: "teal.400",
                          }}
                          isDisabled={loggingIn}
                        >
                          SIGN IN
                        </Button>
                      </FormControl>
                    </form>
                    {/* <Flex
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      maxW="100%"
                      mt="0px"
                    >
                      <Text color={textColor} fontWeight="medium">
                        Forgot Password?
                        <Link color={titleColor} as="span" ms="5px" fontWeight="bold">
                          Reset here
                        </Link>
                      </Text>
                    </Flex> */}
                  </Flex>
                </Flex>
              
              </Flex>
            </Flex>
          </Box>
        </Box>
        <Box px="24px" mx="auto" width="1044px" maxW="100%">
          <Footer />
        </Box>
      </Box>
    </ChakraProvider>
  );
}

export default SignIn;
